export default "__VITE_ASSET__BN3Ro4Qm__"